var scope_0 = require('/codebuild/output/src2935441460/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/289a5d57efa0d168737e4940f6f44793.js').default;
var scope_1 = require('/codebuild/output/src2935441460/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/43bc64ef4f8882aecaa99e56d5250ceb.js').default;
var scope_2 = require('/codebuild/output/src2935441460/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    